import { StopPointHelper } from '../../../../helpers/stop-point.helper';
import type { IStopPoint } from '../../../../models/stop-point.model';

export class StopPointApiModel {
  name!: string;
  gid!: string;
  latitude!: number;
  longitude!: number;
  platform!: string;
  stopPointType!: string;

  public static mapToBusinessModel(apiModel: StopPointApiModel): IStopPoint {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      latitude: apiModel.latitude,
      longitude: apiModel.longitude,
      platform: apiModel.platform,
      stopPointType: StopPointHelper.mapToStopPointType(apiModel.stopPointType),
    };
  }
}
